import { createFileRoute } from "@tanstack/react-router"
import DesignSystemSegmentedControl from "~/pages/design-system/components/SegmentedControl"

export const Route = createFileRoute("/_auth/internal/design-system/components/segmented-control")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemSegmentedControl />
}
